import React from 'react';
import useStore from '../../store/useStore';
import { periodLabel } from '../../utils/cubeQuery';
import PeriodSelect from '../common/PeriodSelect';


/**
 * The period strip under a report or statement widget. Changing it only
 * affects this widget, for this visit (it is not saved); "Default" goes back
 * to the period the widget was set up with. In wall mode it is plain text.
 */
const WidgetPeriodPicker = ({ widgetId, title, defaultPeriod, appliedLabel = null }) => {
  const chosen = useStore((state) => state.widgetPeriods[widgetId] || '');
  const setWidgetPeriod = useStore((state) => state.setWidgetPeriod);
  const wallMode = useStore((state) => state.wallMode);
  const current = chosen || defaultPeriod || '';
  const label = appliedLabel || periodLabel(current);

  if (wallMode) {
    return <div className="widget-period widget-period--static" aria-label={`Period for ${title}`}>{label}</div>;
  }

  return (
    <div className={`widget-period ${chosen ? 'widget-period--changed' : ''}`}>
      <div className="widget-period-field">
        <span>Period</span>
        <PeriodSelect ariaLabel={`Period for ${title}`} value={chosen} onChange={(v) => setWidgetPeriod(widgetId, v || null)}
          emptyLabel={`Default: ${periodLabel(defaultPeriod)}`} ranges="calendar-financial" />
      </div>
      {appliedLabel && <span className="widget-period-range" title="Dates this widget is showing">{appliedLabel}</span>}
    </div>
  );
};

export default WidgetPeriodPicker;
